import React from 'react';
import { CreditCard, Banknote, ArrowLeft, MapPin, Tag, X, Check, Gift, Store, Truck, Clock, Plus, ChevronRight, Trash2, Phone, CalendarDays } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Separator } from '../ui/separator';
import { formatPrice } from '../../lib/utils';
import StampCard from '../StampCard';

const PickupNotesCard = ({
  notes,
  orderType,
  setNotes,
  t,
}) => (
  <>
              {orderType === 'pickup' && (
              <Card className="bg-[#141417] border-[#27272A]">
                <CardContent className="pt-6">
                  <div className="space-y-2">
                    <Label htmlFor="notes">{t('checkout.notes')}</Label>
                    <Textarea
                      id="notes"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      placeholder={t('checkout.notesPlaceholder')}
                      className="bg-[#0B0B0C] border-[#27272A] focus:border-[#FFC107]"
                      data-testid="checkout-notes"
                    />
                  </div>
                </CardContent>
              </Card>
              )}
  </>
);

export default PickupNotesCard;
